module.exports = "data:text/x-markdown;base64,IyMge3sgZmllbGQubmFtZSB9fQoKYHt7IGZpZWxkLm5hbWUgfX1gIGlzIGEgYHt7IGZpZWxkLnR5cGUgfX1gIGZpZWxkLiBFeGFtcGxlIHF1ZXJ5OgoKYGBgClNFTEVDVCAqIEZST00ge3sgdGFibGUgfX0gV0hFUkUge3sgZmllbGQubmFtZSB9fSA9IHt7IGZpZWxkLnNhbXBsZSB9fQpgYGAK"


//////////////////
// WEBPACK FOOTER
// ./src/content/number-field.md
// module id = 313
// module chunks = 0